import { render, staticRenderFns } from "./AccountEmails.vue?vue&type=template&id=b987fdda&"
import script from "./AccountEmails.vue?vue&type=script&lang=js&"
export * from "./AccountEmails.vue?vue&type=script&lang=js&"
import style0 from "./AccountEmails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports